/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimedSessionEventDTO } from './TimedSessionEventDTO';
import {
    TimedSessionEventDTOFromJSON,
    TimedSessionEventDTOFromJSONTyped,
    TimedSessionEventDTOToJSON,
} from './TimedSessionEventDTO';

/**
 * 
 * @export
 * @interface UserSessionDTO
 */
export interface UserSessionDTO {
    /**
     * 
     * @type {Array<TimedSessionEventDTO>}
     * @memberof UserSessionDTO
     */
    events: Array<TimedSessionEventDTO>;
    /**
     * 
     * @type {string}
     * @memberof UserSessionDTO
     */
    sessionId: string;
}

/**
 * Check if a given object implements the UserSessionDTO interface.
 */
export function instanceOfUserSessionDTO(value: object): value is UserSessionDTO {
    if (!('events' in value) || value['events'] === undefined) return false;
    if (!('sessionId' in value) || value['sessionId'] === undefined) return false;
    return true;
}

export function UserSessionDTOFromJSON(json: any): UserSessionDTO {
    return UserSessionDTOFromJSONTyped(json, false);
}

export function UserSessionDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserSessionDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'events': ((json['events'] as Array<any>).map(TimedSessionEventDTOFromJSON)),
        'sessionId': json['sessionId'],
    };
}

export function UserSessionDTOToJSON(value?: UserSessionDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'events': ((value['events'] as Array<any>).map(TimedSessionEventDTOToJSON)),
        'sessionId': value['sessionId'],
    };
}

